module.exports = __webpack_public_path__ + "static/img/product_img1.a0600df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_img1.png
// module id = cs0X
// module chunks = 0